// extracted by mini-css-extract-plugin
module.exports = {"row":"BillsTableHead_row__gApOW","inProduction":"BillsTableHead_inProduction__3PVu2"};